import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export const SelectUser: React.FC = () => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    width="100%"
    gap={2}
    border="1px solid lightgrey"
    borderRadius="4px"
  >
    <AccountCircleIcon fontSize="large" />
    <Typography variant="body1" textTransform="uppercase">
      Please select a user
    </Typography>
  </Box>
);
